export default __webpack_public_path__ + "static/media/detail-3.4cea93c8.png";